import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import MyDayMealCard from './my_day_meal_card';
import PopupTitle from '../common/popup_title';
import { PlannerEntryType } from '../../API';
import {
  dbWeekStartDateStr,
  plannerEntriesInCalendarDay,
} from '../../services/planner';
import { useGetDbPlannerWeekQuery } from '../../app/smorgAppSyncGraphQLApi';
import { calendarDayFromJSDate } from '../../services/dates';

const MyDayTodaysMealsView = () => {
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();

  const todayOverride = searchParams.get('asOf');

  const today = todayOverride || calendarDayFromJSDate(new Date());

  const onClickBack = () => navigate(-1);

  const dbWeekStartDate = dbWeekStartDateStr(today);

  const { data: dbPlannerWeek } = useGetDbPlannerWeekQuery(dbWeekStartDate);

  const todaysMealPlannerEntries = plannerEntriesInCalendarDay(
    dbPlannerWeek,
    today,
  ).filter(
    (plannerEntry) =>
      !plannerEntry.plannerEntryType ||
      plannerEntry.plannerEntryType === PlannerEntryType.MEAL,
  );

  return (
    <div className="my-day-view">
      <div className="topNavBarMobile" style={{ flexDirection: 'column' }}>
        <PopupTitle
          titleText="Today's Meals"
          backButtonEnabled
          onClickBack={onClickBack}
        />
      </div>
      {todaysMealPlannerEntries.map((plannerEntry) => (
        <div key={plannerEntry.mealID} style={{ flexShrink: 0 }}>
          <MyDayMealCard
            mealID={plannerEntry.mealID}
            parentID={dbPlannerWeek.id}
            calendarDay={today}
          />
        </div>
      ))}
    </div>
  );
};

export default MyDayTodaysMealsView;
